export default __webpack_public_path__ + "images/096944e3ca045f24037e12357612caa4-accessories.jpg";